export class AbstractFieldComponent {
    destroy: Function;
    closeModal(): void {
      this.destroy();
    }
  }
